import { nineCollections } from "@/mocks/jiukanliao";
import SectionHeading from "./SectionHeading";

export default function HotNine() {
  const lead = nineCollections[0];
  const rows = nineCollections.slice(1);

  return (
    <section id="hot" className="bg-[#fff9f0] py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="九图吃瓜 · 本周精选"
            title="九宫格图集"
            desc="每套九图都按现场时间轴排好顺序，从左到右、从上到下就是一整条故事线，重点转折用红框帮你圈出来。"
          />
          <a
            href="#hot"
            className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-[#e2cfaa] px-4 py-2 text-[13px] text-[#7a5c2e] transition hover:border-[#d9431f] hover:text-[#b43a17] md:inline-flex"
          >
            查看全部九宫格
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-12">
          {/* 左侧主图 */}
          <a
            href="#alerts"
            className="group relative overflow-hidden rounded-2xl lg:col-span-5"
          >
            <div className="aspect-[4/3] w-full overflow-hidden lg:aspect-auto lg:h-full lg:min-h-[440px]">
              <img
                src={lead.image}
                alt={lead.title}
                className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-[#1c1710]/85 via-[#1c1710]/15 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex items-center gap-2">
                <span className="rounded-full bg-[#ff7a45] px-2.5 py-1 text-[11px] font-semibold text-white">
                  {lead.tag}
                </span>
                <span className="flex items-center gap-1 text-xs text-white/90">
                  <i className="ri-eye-line" />
                  {lead.views} 浏览
                </span>
              </div>
              <h3 className="font-display mt-3 text-xl font-bold leading-snug text-white md:text-2xl">
                {lead.title}
              </h3>
              <p className="mt-2 line-clamp-2 max-w-md text-[13px] leading-6 text-white/80">
                {lead.summary}
              </p>
            </div>
          </a>

          {/* 右侧编号横行 */}
          <div className="flex flex-col gap-4 lg:col-span-7 lg:pl-2">
            {rows.map((item, idx) => (
              <a
                key={item.title}
                href="#alerts"
                className="group flex items-center gap-4 overflow-hidden rounded-2xl bg-white p-3 ring-1 ring-[#eadbc0] transition hover:ring-[#d9b67a] md:gap-5 md:p-4"
              >
                <div className="relative hidden h-full w-40 shrink-0 self-stretch overflow-hidden rounded-xl sm:block md:w-48">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="relative min-w-0 flex-1 py-1">
                  <span className="font-latin pointer-events-none absolute -top-3 right-0 text-5xl font-bold text-[#f4e7cf]">
                    {String(idx + 2).padStart(2, "0")}
                  </span>
                  <div className="flex items-center gap-2 pr-10">
                    <span className="rounded-full bg-[#fff1e2] px-2.5 py-0.5 text-[11px] font-medium text-[#b43a17]">
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 text-[11px] text-[#a48a5d]">
                      <i className="ri-eye-line" />
                      {item.views}
                    </span>
                  </div>
                  <h3 className="font-display mt-2 truncate text-[15px] font-bold text-[#231f18] md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 line-clamp-2 text-[13px] leading-6 text-[#8a7a5d]">
                    {item.summary}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}